var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 0.5C2.36917 0.5 0.5 2.36917 0.5 4.66667V11.3333C0.5 13.6308 2.36917 15.5 4.66667 15.5H11.3333C13.6308 15.5 15.5 13.6308 15.5 11.3333V4.66667C15.5 2.36917 13.6308 0.5 11.3333 0.5H4.66667ZM4.66667 2.16667H11.3333C12.7117 2.16667 13.8333 3.28833 13.8333 4.66667V11.3333C13.8333 12.7117 12.7117 13.8333 11.3333 13.8333H4.66667C3.28833 13.8333 2.16667 12.7117 2.16667 11.3333V4.66667C2.16667 3.28833 3.28833 2.16667 4.66667 2.16667ZM12.1667 3C11.9457 3 11.7337 3.0878 11.5774 3.24408C11.4211 3.40036 11.3333 3.61232 11.3333 3.83333C11.3333 4.05435 11.4211 4.26631 11.5774 4.42259C11.7337 4.57887 11.9457 4.66667 12.1667 4.66667C12.3877 4.66667 12.5996 4.57887 12.7559 4.42259C12.9122 4.26631 13 4.05435 13 3.83333C13 3.61232 12.9122 3.40036 12.7559 3.24408C12.5996 3.0878 12.3877 3 12.1667 3ZM8 3.83333C5.7025 3.83333 3.83333 5.7025 3.83333 8C3.83333 10.2975 5.7025 12.1667 8 12.1667C10.2975 12.1667 12.1667 10.2975 12.1667 8C12.1667 5.7025 10.2975 3.83333 8 3.83333ZM8 5.5C9.37833 5.5 10.5 6.62167 10.5 8C10.5 9.37833 9.37833 10.5 8 10.5C6.62167 10.5 5.5 9.37833 5.5 8C5.5 6.62167 6.62167 5.5 8 5.5Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram_icon.b45e619642c87aadfb810737b35e342c.svg";
export { ForwardRef as ReactComponent };